import { ENDPOINT_TYPE, DEV_WS_URL, DEV_API_URL } from 'shared/constants';

export const getWindowGlobalEndpoint = (endpointType) => window?.globalConfig[endpointType];

export const getHost = ({ globalHost, endpointType }) => {
  if (globalHost) return globalHost;
  if (endpointType === ENDPOINT_TYPE.WebSocket) return DEV_WS_URL;
  if (endpointType === ENDPOINT_TYPE.Api) return DEV_API_URL;
  throw new Error('Invalid endpoint type');
};

export const getWsHost = () => getHost({
  globalHost: getWindowGlobalEndpoint(ENDPOINT_TYPE.WebSocket),
  endpointType: ENDPOINT_TYPE.WebSocket,
});

export const getApiHost = () => getHost({
  globalHost: getWindowGlobalEndpoint(ENDPOINT_TYPE.Api),
  endpointType: ENDPOINT_TYPE.Api,
});

export const getStreamerHost = () =>  {
  const host = getHost({
    globalHost: getWindowGlobalEndpoint(ENDPOINT_TYPE.WebSocket),
    endpointType: ENDPOINT_TYPE.WebSocket,
  });

  if (host.includes('uat')) {
    return 'https://npasimulcastwebstreameruat.npauctions.com'
  }

  if (host.includes('stage')) {
    return 'https://npasimulcastwebstreamerstage.npauctions.com'
  }

  return 'https://npasimulcastwebstreamer.npauctions.com'
};
